import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCoreIssueTypesRoute: InvariantJiraRoute = {
	name: 'project-settings-core-issuetypes',
	path: '/jira/core/projects/:projectKey/settings/issuetypes/:issueTypeId?',
	exact: true,
};
